import { ICardDescriptionUnsavedState } from '../types';

export const CARD_DESCRIPTION_UNSAVED_LOCALSTORAGE = 'CARD_DESCRIPTION_UNSAVED_LOCALSTORAGE';

export interface ICardDescriptionUnsavedLocalStorage extends ICardDescriptionUnsavedState {
};
